















import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {CashoutData} from "../models";
import {cashoutEventBus, CashoutEvents, CheckoutErrorModes} from "../bus";

@Component
export default class DebugTools extends Vue {
    @Prop()
    cashoutData!: CashoutData;

    emitAuthExpired() {
        cashoutEventBus.$emit(CashoutEvents.CHECKOUT_ERROR, CheckoutErrorModes.AUTH_EXPIRED, "login fella")
    }

    emit2faRequired() {
        cashoutEventBus.$emit(CashoutEvents.CHECKOUT_ERROR, CheckoutErrorModes.AUTH_2FA_REQUIRED, "2fa is needed")
    }

    emit2faInvalid() {
        cashoutEventBus.$emit(CashoutEvents.CHECKOUT_ERROR, CheckoutErrorModes.AUTH_2FA_INVALID, "wrong code!")
    }

    emitRateChange() {
        cashoutEventBus.$emit(CashoutEvents.CHECKOUT_ERROR, CheckoutErrorModes.RATE_NO_LONGER_VALID, "rate no longer valid")

    }

    emitInsufficientFunds() {
        cashoutEventBus.$emit(CashoutEvents.CHECKOUT_ERROR, CheckoutErrorModes.INSUFFICIENT_FUNDS, "no monies!")
    }

    emitValidationError() {
        cashoutEventBus.$emit(CashoutEvents.CHECKOUT_ERROR, CheckoutErrorModes.VALIDATION_ERROR, "server-side validation failed")

    }

    emitGenericError() {
        cashoutEventBus.$emit(CashoutEvents.CHECKOUT_ERROR, CheckoutErrorModes.GENERIC_ERROR, "500")

    }

    emitFailure() {
        cashoutEventBus.$emit(CashoutEvents.CHECKOUT_FAILURE)
    }

    emitUiBlock() {
        cashoutEventBus.$emit(CashoutEvents.UI_BLOCK)
    }

    emitUiUnblock() {
        cashoutEventBus.$emit(CashoutEvents.UI_UNBLOCK)
    }
}
